import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterCO',
    pure: false
})
export class filterCOPipe implements PipeTransform {
    transform(items: Array<any>,cc:string, co: string): any {
        if(items){
            return items.filter(item => item.centrosCusto[cc] && item.contaOrcamentaria == co);
        }
    }
}